export function formatDistance(distanceMeters?: number | null): string | null {
  if (typeof distanceMeters !== "number" || Number.isNaN(distanceMeters) || distanceMeters <= 0) {
    return null;
  }
  if (distanceMeters < 1000) {
    return `${Math.round(distanceMeters)} m`;
  }
  const km = distanceMeters / 1000;
  return `${km.toFixed(km < 10 ? 1 : 0)} km`;
}

export function formatDuration(durationSeconds?: number | null): string | null {
  if (typeof durationSeconds !== "number" || Number.isNaN(durationSeconds) || durationSeconds <= 0) {
    return null;
  }
  const minutes = Math.max(1, Math.round(durationSeconds / 60));
  return `${minutes} min`;
}
